export const buildUsers = (users, profiles) =>
    users.map(user => buildUser(user, profiles));

const buildUser = (user, profiles) => ({
    ...user,
    company: Array.isArray(user.company) ? user.company[0] : user.company,
    profile: profiles ? buildUserProfile(user.profile, profiles) : user.profile,
    displayName: `${user.name} ${user.last_name}`,
    displayNameWithUsername: `${user.name} ${user.last_name} (${user.username})`
});

const buildUserProfile = (user_profile, profiles) => {
    if (!Array.isArray(user_profile) || !user_profile.length || !profiles) return null;
    return profiles.find(profile => profile._id === user_profile[0]._id);
};

